import { capitalize } from "lodash";
import { useI18n } from "vue-i18n";
import { computed } from "vue";

export function useIntervals() {
    const { t } = useI18n();

    const intervals = computed(() => {
        return [
            {
                id: "daily",
                label: capitalize(t("admin.tasks.recurring.interval.daily")),
            },
            {
                id: "weekly",
                label: capitalize(t("admin.tasks.recurring.interval.weekly")),
            },
            {
                id: "monthly",
                label: capitalize(t("admin.tasks.recurring.interval.monthly")),
            },
            {
                id: "yearly",
                label: capitalize(t("admin.tasks.recurring.interval.yearly")),
            },
        ];
    });
    return {
        intervals,
    };
}
